export const Api = {
  login: '/api/auth/login',
  refreshToken: '/api/auth/refresh-token',
  requestResign: 'http://app-deploy.haier.net/ipa/br/reSignRecord/saveReSignRecord',
  queryResign: 'http://app-deploy.haier.net/ipa/br/fileInfo/queryInfoById',
  upload: '',
  getSTSToken: '/api/base/get-ali-sts-token',
  forwardRequest: '/api/base/forward-request',
  // 用户管理
  getUserList: '/api/user/search-user-list',
  addUser: '/api/user/add-user',
  updateUser: '/api/user/update-user',
  deleteUser: '/api/user/delete-user',
  // 菜单管理
  getMenuList: '/api/menu/search-menu-list',
  addMenu: '/api/menu/add-menu',
  updateMenu: '/api/menu/update-menu',
  deleteMenu: '/api/menu/delete-menu',
  getMenuListForUser: '/api/menu/search-menu-list-for-user',
  // 角色管理
  getRoleList: '/api/role/search-role',
  addRole: '/api/role/add-role',
  updateRole: '/api/role/update-role',
  deleteRole: '/api/role/delete-role',
  // 部门管理
  getDepartmentList: '/api/department/search-department-list',
  addDepartment: '/api/department/add-department',
  updateDepartment: '/api/department/update-department',
  deleteDepartment: '/api/department/delete-department',
  // 权限对照
  restAuthCode: '/api/auth-code',
  findAuthCodeList: '/api/auth-code/trees',
  // LDAP
  addLDAPConfig: '/api/ldap/create',
  getLDAPList: '/api/ldap/find-all',
  getLDAPDetail: '/api/ldap/find-one',
  updateLDAPConfig: '/api/ldap/update',
  removeLDAPConfig: '/api/ldap/remove',
  testLDAPConfig: '/api/ldap/test',
  changeValid: '/api/ldap/change-valid',
  syncUserList: '/api/ldap/sync-user-list',
  // 用户行为
  searchUserActionList: '/api/log/user-action/search',
  // 部署发版
  casarstDeploy: '/api/devops/casarte/build',
  searchCasarstDeploy: '/api/devops/casarte/search-build',
  getCasarstBuildProduct: '/api/devops/casarte/get-build-product',
  checkDevopsAuth: '/api/devops/check-devops-auth',
  // 办公软件
  getSoftwareClassifyList: '/api/static/software/get-software-classify-list',
  getSystemClassifyList: '/api/static/software/get-system-classify-list',
  getSoftwareList: '/api/static/software/get-software-list',
  addSoftware: '/api/static/software/add-software',
  editSoftware: '/api/static/software/edit-software',
  deleteSoftware: '/api/static/software/delete-software',
  addVersion: '/api/static/software/add-version',
  getSoftwareDetail: '/api/static/software/get-software-detail',
  deleteVersion: '/api/static/software/delete-software-version',
  // 线上图片
  searchImageList: '/api/static/online-image/search',
  createImage: '/api/static/online-image/create',
  updateImage: '/api/static/online-image/update',
  deleteImage: '/api/static/online-image/delete',
  getImageDetail: '/api/static/online-image/detail',
  searchImageTagList: '/api/static/online-image/search-tag-list',
  // 静态文件
  searchStaticFileList: '/api/static/static-file/search',
  uploadStaticFile: '/api/static/static-file/create',
  updateStaticFile: '/api/static/static-file/update',
  deleteStaticFile: '/api/static/static-file/delete',
  getStaticFileDetail: '/api/static/static-file/detail',
  // shell控制台
  addShellConfig: '/api/web-shell/add',
  getShellConfigList: '/api/web-shell/list',
  updateShellConfig: '/api/web-shell/update',
  deleteShellConfig: '/api/web-shell/delete',
  openShellConnect: '/api/web-shell/open-connect',
  // sentry动态配置
  addIgnoreConfig: '/api/sentry-monitor/config/add-ignore-config',
  searchIgnoreConfig: '/api/sentry-monitor/config/search-ignore-config',
  editIgnoreConfig: '/api/sentry-monitor/config/edit-ignore-config',
  deleteIgnoreConfig: '/api/sentry-monitor/config/delete-ignore-config',
  searchConfigList: '/api/sentry-monitor/config/search-config-list',
  searchConfigDetail: '/api/sentry-monitor/config/search-config-detail',
  addSentryConfig: '/api/sentry-monitor/config/add-sentry-config',
  updateSentryConfig: '/api/sentry-monitor/config/update-sentry-config',
  changeConfigStatus: '/api/sentry-monitor/config/change-config-status',
  deleteSentryConfig: '/api/sentry-monitor/config/delete-sentry-config',
  // 配置中心
  searchHaierAccountConfig: '/api/config-center/haier-account/search-owner-account',
  updateHaierAccountConfig: '/api/config-center/haier-account/update-owner-account',
  // 工作看板
  getAccountInfo: '/api/kanban/hds-week-report/get-account-info',
  addHostSslChecker: '/api/kanban/ssl-valid/add-host-checker',
  searchHostSslCheckerList: '/api/kanban/ssl-valid/search-host-checker-list',
  deleteHostSslChecker: '/api/kanban/ssl-valid/delete-host-checker',
  // 代码模版
  searchCodeTemplateList: '/api/efficient-office/code-template/search-code-template-list',
  getCodeTemplateDetail: '/api/efficient-office/code-template/get-code-template-detail',
  insertCodeTemplateItem: '/api/efficient-office/code-template/insert-code-template-item',
  updateCodeTemplateItem: '/api/efficient-office/code-template/update-code-template-item',
  deleteCodeTemplateItem: '/api/efficient-office/code-template/delete-code-template-item',
  setCodeTemplateItemLog: '/api/efficient-office/code-template/set-code-template-item-log',
  getCodeTemplateItemLog: '/api/efficient-office/code-template/get-code-template-item-log',
  //   书签管理
  searchBookmarkList: '/api/efficient-office/bookmark/search-bookmark-list',
  addBookmark: '/api/efficient-office/bookmark/add-bookmark',
  deleteOneBookmark: '/api/efficient-office/bookmark/delete-one-bookmark',
  updateBookmark: '/api/efficient-office/bookmark/update-bookmark',
  //   字典管理
  searchDictList: '/api/sys-dict/search-dict-list',
  addDict: '/api/sys-dict/add-dict',
  getDictAll: '/api/sys-dict/get-dict-all',
  deleteOneItem: '/api/sys-dict/delete-one-item',
  changeSort: '/api/sys-dict/change-sort',
  // 精武门
  addFistOfFury: '/api/efficient-office/fist-of-fury',
  searchFistOfFuryList: '/api/efficient-office/fist-of-fury/list',
  searchFistOfFuryDetail: '/api/efficient-office/fist-of-fury/',
  updateFistOfFury: '/api/efficient-office/fist-of-fury/',
  deleteFistOfFury: '/api/efficient-office/fist-of-fury/',
  // 研发效能
  getRDCronTask: '/api/rd-efficiency/cron-task/get-r-d-cron-task',
  setCloseExpireTaskStatus: '/api/rd-efficiency/cron-task/set-close-expire-task-status',
  setSyncExpendToTask: '/api/rd-efficiency/cron-task/set-sync-expend-to-task',
  // 任务管理
  getByWorkspaceTaskList: '/api/rd-efficiency/task-manage/get-by-workspace-task-list',
  getByWorkspaceStoryList: '/api/rd-efficiency/task-manage/get-by-workspace-story-list',
  getMissionTypeList: '/api/rd-efficiency/task-manage/get-mission-type-list',
  getMissionStatusList: '/api/rd-efficiency/task-manage/get-mission-status-list',
  getHourCountForUser: '/api/rd-efficiency/task-manage/get-hour-count-for-user',
  createTask: '/api/rd-efficiency/task-manage/create-task',
  checkNameDescription: '/api/rd-efficiency/task-manage/check-name-description',
  deleteTask: '/api/rd-efficiency/task-manage/delete-task',
  getByWorkspaceBugList: '/api/rd-efficiency/task-manage/get-by-workspace-bug-list',
  getByWorkspaceAndTaskHourList: '/api/rd-efficiency/task-manage/get-by-workspace-and-task-hour-list',
  // 员工分组
  searchUserLeaderRelationList: '/api/user-leader-relation/search-user-leader-relation-list',
  saveUserLeaderRelation: '/api/user-leader-relation/save-user-leader-relation',
  deleteUserLeaderRelation: '/api/user-leader-relation/delete-user-leader-relation',
  searchUserList: '/api/user-leader-relation/search-user-list',
  searchHaierAccount: '/api/user-leader-relation/search-haier-account',
  getUserLeaderAccount: '/api/user-leader-relation/get-user-leader-account',
  // 工程仓库目录（多智能体挂载等仍使用）
  claudeReposListCatalog: '/api/claude/repos/list-catalog',
  // CBAgent（Cursor Based Agent）
  cbagentModelsList: '/api/cbagent/models/list',
  cbagentSessionsCreate: '/api/cbagent/sessions/create',
  cbagentSessionsList: '/api/cbagent/sessions/list',
  cbagentSessionsGetMessages: '/api/cbagent/sessions/get-messages',
  cbagentSessionsGetBlob: '/api/cbagent/sessions/get-blob',
  cbagentSessionsRename: '/api/cbagent/sessions/rename',
  cbagentSessionsPin: '/api/cbagent/sessions/pin',
  cbagentSessionsDelete: '/api/cbagent/sessions/delete',
  cbagentSessionsCancelRun: '/api/cbagent/sessions/cancel-run',
  cbagentSessionsRunStatus: '/api/cbagent/sessions/run-status',
  cbagentSessionsSend: '/api/cbagent/sessions/send',
  cbagentUpload: '/api/cbagent/upload',
  cbagentSkillsList: '/api/cbagent/skills/list',
  cbagentSkillsCreate: '/api/cbagent/skills/create',
  cbagentSkillsImportZip: '/api/cbagent/skills/import-zip',
  cbagentSkillsGet: '/api/cbagent/skills/get',
  cbagentSkillsReadFile: '/api/cbagent/skills/read-file',
  cbagentSkillsSaveFile: '/api/cbagent/skills/save-file',
  cbagentSkillsSave: '/api/cbagent/skills/save',
  cbagentSkillsUploadZip: '/api/cbagent/skills/upload-zip',
  cbagentSkillsSubscribe: '/api/cbagent/skills/subscribe',
  cbagentSkillsUnsubscribe: '/api/cbagent/skills/unsubscribe',
  cbagentSkillsDelete: '/api/cbagent/skills/delete',
  cbagentSkillsCopy: '/api/cbagent/skills/copy',
  cbagentSkillsShare: '/api/cbagent/skills/share',
  cbagentSkillsForceSubscribe: '/api/cbagent/skills/force-subscribe',
  cbagentRulesList: '/api/cbagent/rules/list',
  cbagentRulesGet: '/api/cbagent/rules/get',
  cbagentRulesSave: '/api/cbagent/rules/save',
  cbagentRulesDelete: '/api/cbagent/rules/delete',
  cbagentAuthMe: '/api/cbagent/auth/me',
  cbagentAuthRoles: '/api/cbagent/auth/roles',
  cbagentAuthWelcome: '/api/cbagent/auth/welcome',
  cbagentAuthSetMine: '/api/cbagent/auth/set-mine',
  cbagentAuthSetUser: '/api/cbagent/auth/set-user',
  // 多智能体 - LLM 模型配置管理
  getLLMConfigList: '/api/multi-agent/llm-config',
  createLLMConfig: '/api/multi-agent/llm-config',
  getLLMConfigPresets: '/api/multi-agent/llm-config/presets',
  getLLMConfigDetail: '/api/multi-agent/llm-config',
  updateLLMConfig: '/api/multi-agent/llm-config',
  deleteLLMConfig: '/api/multi-agent/llm-config',
  testLLMConnection: '/api/multi-agent/llm-config',
  setDefaultLLM: '/api/multi-agent/llm-config/set-default',
  // 多智能体 - 智能体管理
  getAgentList: '/api/multi-agent/agents',
  agentChat: '/api/multi-agent/agents',
  createAgent: '/api/multi-agent/agents',
  getBuiltInAgents: '/api/multi-agent/agents/builtin',
  getSceneAgents: '/api/multi-agent/agents/scenes',
  getAgentDetail: '/api/multi-agent/agents',
  updateAgent: '/api/multi-agent/agents',
  deleteAgent: '/api/multi-agent/agents',
  getLearnedCapabilities: '/api/multi-agent/agents',
  resetCapabilities: '/api/multi-agent/agents',
  // 多智能体 - Crew 团队管理
  getCrewList: '/api/multi-agent/crews',
  createCrew: '/api/multi-agent/crews',
  getCrewDetail: '/api/multi-agent/crews',
  deleteCrew: '/api/multi-agent/crews',
  kickoffCrew: '/api/multi-agent/crews',
  // 多智能体 - 协同对话
  multiAgentChatSend: '/api/multi-agent/chat/send',
  multiAgentChatUploadFile: '/api/multi-agent/chat/upload-file',
  // 多智能体 - 任务管理
  getMultiAgentTaskList: '/api/multi-agent/tasks',
  createMultiAgentTask: '/api/multi-agent/tasks',
  getMultiAgentTaskDetail: '/api/multi-agent/tasks',
  deleteMultiAgentTask: '/api/multi-agent/tasks',
  // 多智能体 - 技能管理
  getSkillList: '/api/multi-agent/skills',
  createSkill: '/api/multi-agent/skills',
  getSkillDetail: '/api/multi-agent/skills',
  updateSkill: '/api/multi-agent/skills',
  deleteSkill: '/api/multi-agent/skills',
  installSkill: '/api/multi-agent/skills/install',
  uninstallSkill: '/api/multi-agent/skills/uninstall',
  getAgentSkills: '/api/multi-agent/skills/agent',
  getAvailableSkills: '/api/multi-agent/skills/available',
  syncSkillsWorkspace: '/api/multi-agent/skills/sync-workspace',

  // 多智能体 - 工程挂载订阅管理
  listMountedProjects: '/api/multi-agent/mounted-projects',
  subscribeMountedProjects: '/api/multi-agent/mounted-projects/subscribe',
  unsubscribeMountedProjects: '/api/multi-agent/mounted-projects/unsubscribe',
  remountMountedProjects: '/api/multi-agent/mounted-projects/remount',
  uploadScanCache: '/api/multi-agent/mounted-projects/upload-scan-cache',
  refreshScanCache: '/api/multi-agent/mounted-projects/refresh-scan-cache',
  scanCacheStatus: '/api/multi-agent/mounted-projects/scan-cache-status',
  deleteScanCache: '/api/multi-agent/mounted-projects/delete-scan-cache'
}
